import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectionCriteria} from './ConnectionCriteria';
import {FTPConnection} from '../message/FTPConnection';

export class FTPConnectionWrapper extends BaseWrapper<FTPConnection, ConnectionCriteria, BasicScenario>  {}

